module.exports = __webpack_public_path__ + "static/media/escalada.3bf03549.jpg";